import { render, staticRenderFns } from "./AppIconCard.vue?vue&type=template&id=10a9c0e0&functional=true&"
import script from "./AppIconCard.vue?vue&type=script&lang=js&"
export * from "./AppIconCard.vue?vue&type=script&lang=js&"
import style0 from "./AppIconCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports